const component = "ui-button-select" as const;

export const buttonSelectDataTestIds = {
  component,
};
